import { render, staticRenderFns } from "./getInsaView.vue?vue&type=template&id=ddfcf3e8&scoped=true&"
import script from "./getInsaView.vue?vue&type=script&lang=js&"
export * from "./getInsaView.vue?vue&type=script&lang=js&"
import style0 from "./getInsaView.vue?vue&type=style&index=0&id=ddfcf3e8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddfcf3e8",
  null
  
)

export default component.exports